// built-in imports
import React from "react";
import { Tilt } from "react-tilt";
import { motion } from "framer-motion";
import { FaCirclePlay } from "react-icons/fa6";

// internal imports
import { fadeIn, textVariant } from "../../utils/motion/motion.utils";
import { useAppContext } from "../../layout/layout";
import Slider from "../tags-slider/tags-slider.component";

const ProjectCard = ({
  index,
  en_title,
  de_title,
  imageUrl,
  en_info,
  de_info,
  tags,
  source_code_link,
  live_demo_link,
}) => {
  const { lang } = useAppContext();
  return (
    <div className=" m-2">
      <div
        className="bg-tertiary p-5 rounded-2xl sm:w-[360px] w-full"
        style={{ backgroundColor: "var(--background-secondary-color)" }}
      >
        <div className="relative w-full h-[250px]">
          <img
            src={imageUrl}
            alt="project_image"
            className="w-full h-full rounded-2xl border"
            style={{ border: "1px solid var(--text-color)" }}
          />

          <div className="absolute inset-0 flex gap-x-2 justify-end m-3">
            {source_code_link !== "" && (
              <div
                onClick={() => window.open(source_code_link, "_blank")}
                className=" black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer"
              >
                <img
                  src="/assets/github.png"
                  alt="source code"
                  className="w-1/2 h-1/2 object-contain"
                />
              </div>
            )}
            {live_demo_link != "" && (
              <div
                onClick={() => window.open(live_demo_link, "_blank")}
                className=" black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer"
              >
                <FaCirclePlay className="w-4 h-4" />
              </div>
            )}
          </div>
        </div>

        <div className="mt-5 flex flex-col items-start overflow-hidden h-[180px]">
          <h3 className="text-white font-bold text-[20px] md:text-[24px]">
            {lang === "en" ? en_title : de_title}
          </h3>
          <p className=" text-secondary text-[14px]">
            {lang === "en" ? en_info : de_info}
          </p>
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <p
              key={`key-${tag.name}-${tag.name}`}
              className={`text-[14px] m-0 ${tag.color}`}
            >
              #{tag.name}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
